import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import styles from "./TestimonialsBox.module.css";

const TestimonialsBox = () => {
  const [playingIdMobile, setPlayingIdMobile] = useState(null);
const [playingIdDesktop, setPlayingIdDesktop] = useState(null);

  const shortsData = [
    { id: "t0Ycvkt270k", title: "Solar Storage Box and Charging Station" },
    { id: "TMXH4OqEOOw", title: "54kW Ecoflow Delta Pro Ultra + Solar Installation" },
    { id: "k97VyRKAy7M", title: "EP Cube Installation and Solar Array" },
    { id: "buK2vSmCuus", title: "Solar Panel Installation" },
    { id: "2WtIaCVxxK8", title: "EcoFlow Delta Pro Ultra + Smart Home Panel " },
  ];

  return (
    <section style={{ padding: "40px 0", background: "#ffffff" }}>
       <div  className={styles['mobile-only']}>
        <Container>
        <div>
          {shortsData.map((short) => (
            <div>
              <div 
                style={{ 
                  position: "relative",
                  width: "100%",
                  paddingTop: "177.77%", 
                  backgroundColor: "#1a1a1a",
                  borderRadius: "16px",
                  overflow: "hidden",
                  boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                  
                  transform: "translate3d(0,0,0)" 
                }}
              >
                {playingIdMobile === short.id ? (
                  <iframe
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      border: "0"
                    }}
                    src={`https://www.youtube.com/embed/${short.id}?autoplay=1&rel=0&playsinline=1`}
                    title={short.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                ) : (
                  <div 
                    onClick={() => setPlayingIdMobile(short.id)}
                    style={{ 
                      position: "absolute", 
                      top: 0, 
                      left: 0, 
                      width: "100%", 
                      height: "100%", 
                      cursor: "pointer" 
                    }}
                  >
                    <img 
                      src={`https://img.youtube.com/vi/${short.id}/hqdefault.jpg`} 
                      alt={short.title}
                      style={{ 
                        position: "absolute", 
                        top: 0, 
                        left: 0, 
                        width: "100%", 
                        height: "100%", 
                        objectFit: "cover" 
                      }}
                    />
                    <div style={{
                      position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
                      backgroundColor: "rgba(255, 0, 0, 0.9)", borderRadius: "50%", width: "60px", height: "60px",
                      display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 0 20px rgba(0,0,0,0.3)"
                    }}>
                       <svg width="30" height="30" viewBox="0 0 24 24" fill="white"><path d="M8 5v14l11-7z"/></svg>
                    </div>
                  </div>
                )}
              </div>
              <h5 className="text-center mt-3" style={{ fontWeight: "600", padding: "10px", fontSize: "1.1rem" }}>
                {short.title}
              </h5>
            </div>
          ))}
        </div>
      </Container>
        </div>

        <div className={styles['desktop-only']}>
      <Container>
        <Swiper
          spaceBetween={20}
          observer={true} 
          observeParents={true}
          breakpoints={{
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          style={{ width: "100%", height: "auto" }}
        >
          {shortsData.map((short) => (
            <SwiperSlide key={short.id}>
              <div 
                style={{ 
                  position: "relative",
                  width: "100%",
                  paddingTop: "177.77%", 
                  backgroundColor: "#1a1a1a", 
                  borderRadius: "16px",
                  overflow: "hidden",
                  boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                  
                  transform: "translate3d(0,0,0)" 
                }}
              >
                {playingIdDesktop === short.id ? (
                  <iframe
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      border: "0"
                    }}
                    src={`https://www.youtube.com/embed/${short.id}?autoplay=1&rel=0&playsinline=1`}
                    title={short.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                ) : (
                  <div 
                    onClick={() => setPlayingIdDesktop(short.id)}
                    style={{ 
                      position: "absolute", 
                      top: 0, 
                      left: 0, 
                      width: "100%", 
                      height: "100%", 
                      cursor: "pointer" 
                    }}
                  >
                    <img 
                      src={`https://img.youtube.com/vi/${short.id}/hqdefault.jpg`} 
                      alt={short.title}
                      style={{ 
                        position: "absolute", 
                        top: 0, 
                        left: 0, 
                        width: "100%", 
                        height: "100%", 
                        objectFit: "cover" 
                      }}
                    />
                    <div style={{
                      position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
                      backgroundColor: "rgba(255, 0, 0, 0.9)", borderRadius: "50%", width: "60px", height: "60px",
                      display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 0 20px rgba(0,0,0,0.3)"
                    }}>
                       <svg width="30" height="30" viewBox="0 0 24 24" fill="white"><path d="M8 5v14l11-7z"/></svg>
                    </div>
                  </div>
                )}
              </div>
              <h5 className="text-center mt-3" style={{ fontWeight: "600", padding: "10px", fontSize: "1.1rem" }}>
                {short.title}
              </h5>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
      </div>
    </section>
  );
};

export default TestimonialsBox;